/**
 * D42 -- Persona helper.
 * D54-d Group F -- Migrated to consult the layered RBAC matrix
 * key `ceo_persona_ui` instead of reading `user.role` directly.
 * Guarantees parity while removing another `user.role ===` literal
 * from the frontend on the path to retiring the field entirely.
 *
 * Returns true when the currently-authenticated user has the
 * `ceo_persona_ui` matrix cell = True (CEO by default). Prefer this
 * hook over inline ``user?.role === "CEO"`` checks so every persona-driven
 * UX omission (hide "My Leaves", hide "My Claims", CEO cockpit toggles, ...)
 * routes through a single canonical predicate.
 *
 * Guardrails:
 *   - This is a UX hint, NEVER an authorization gate. Server routes still
 *     enforce their own RBAC (see ``core/rbac_matrix.py``).
 *   - Missing user (pre-hydrate, logged out) returns ``false``.
 *   - Missing matrix (auth still loading) returns ``false`` -- use
 *     ``useMatrixLoaded()`` if a caller needs to distinguish loading
 *     from denied.
 */
import { useMatrix } from "@/hooks/usePermission";

export function useIsCEO() {
  return useMatrix("ceo_persona_ui");
}

export default useIsCEO;
